<template>
  <v-app :style="appStyle">
    <v-layout class="layout-content">
      <v-main>
        <RouterView></RouterView>
      </v-main>
    </v-layout>
    <Alert />
  </v-app>
</template>


<script setup>
import { onMounted, onUnmounted } from 'vue'
import { initGlobalWebSocket, closeGlobalWebSocket } from '@/composables/useGlobalWebSocket'

onMounted(() => {
  // 初始化全局WebSocket连接（整个应用共享）
  initGlobalWebSocket()
})

onUnmounted(() => {
  // 关闭全局WebSocket连接
  closeGlobalWebSocket()
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F7F7F7;
}

.layout-content {
  height: 100%;
  width: 100%;
}

::-webkit-scrollbar {
  width: 2px;
  /* 竖向滚动条宽度 */
  height: 2px;
  /* 横向滚动条高度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* 滚动条样式 */
  -webkit-box-shadow: inset 0 0 3px 000;
  /* 内阴影 */
  background-color: #000;
  /* 滚动条颜色 */
}
</style>
